export default {
  cartSummaryTitle: {
    id: 'funnel_summary_title_without_details',
    defaultMessage: 'Summary',
  },
  returnInfoBlockTitle: {
    id: 'bouygues_in_store_cart_step_return_info_block_title',
    defaultMessage: "Retour gratuit du téléphone jusqu'au 31 janvier",
  },
  returnInfoBlockDescription: {
    id: 'bouygues_in_store_cart_step_return_info_block_description',
    defaultMessage:
      'Tout changement de votre forfait Bouygues Telecom doit être fait sous 30 jours après achat.',
  },
}
